import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './header.css';
import logo from '../../resources/images/logo.png'

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Chiudi il menu mobile quando si ridimensiona la finestra
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setIsMobileMenuOpen(false);
        setActiveDropdown(null);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Chiudi il menu mobile quando si clicca fuori
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.main-header')) {
        setIsMobileMenuOpen(false);
        setActiveDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileMenuOpen]);

  // Blocca lo scroll del body quando il menu mobile è aperto
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setActiveDropdown(null);
  };

  const toggleDropdown = (menuName) => {
    setActiveDropdown(activeDropdown === menuName ? null : menuName);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <header className="main-header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="ScoutballItalia" />
            <span className="logo-text">SCOUTBALL<span className="italia">ITALIA</span></span>
          </Link>
        </div>
        
        <nav className="main-nav">
          <ul>
            <li><Link to="/">HOME</Link></li>
            <li><Link to="/pattuglia">PATTUGLIA</Link></li>
            <li className="dropdown">
              <span className="nav-header">TORNEI <i className="fas fa-chevron-down"></i></span>
              <ul className="dropdown-menu">
                <li><Link to="/tornei/iscrizioni">Iscrizioni</Link></li>
                <li><Link to="/tornei/organizza">Organizza</Link></li>
                <li><Link to="/tornei/statistiche">Statistiche</Link></li>
              </ul>
            </li>
            <li className="dropdown">
              <span className="nav-header">BRANCHE <i className="fas fa-chevron-down"></i></span>
              <ul className="dropdown-menu">
                <li><Link to="/branche/lc">Gioco</Link></li>
                <li><Link to="/branche/eg">Avventura</Link></li>
                <li><Link to="/branche/rs">Servizio</Link></li>
              </ul>
            </li>
            <li><Link to="/regolamento">REGOLAMENTO</Link></li>
            <li><Link to="/foto">FOTO</Link></li>
            <li><Link to="/contatti">CONTATTI</Link></li>
          </ul>
        </nav>
        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className="burger-line"></span>
          <span className="burger-line"></span>
          <span className="burger-line"></span>
        </button>
      </div>

      {/* Mobile Menu Overlay - AGGIUNTO */}
      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}>
        <nav className="mobile-nav">
          <div className="mobile-nav-header">
            <div className="mobile-nav-logo">
              <span className="logo-text">
                SCOUTBALL<span className="italia">ITALIA</span>
              </span>
            </div>
            <button 
              className="mobile-menu-close"
              onClick={closeMobileMenu}
              aria-label="Close mobile menu"
            >
              ×
            </button>
          </div>

          <ul className="mobile-nav-menu">
            <li>
              <Link to="/" onClick={closeMobileMenu}>
                <i className="fas fa-home"></i>
                Home
              </Link>
            </li>
            
            <li>
              <Link to="/pattuglia" onClick={closeMobileMenu}>
                <i className="fas fa-users"></i>
                Pattuglia
              </Link>
            </li>
            
            <li className={`mobile-dropdown ${activeDropdown === 'tornei' ? 'active' : ''}`}>
              <button 
                className="mobile-dropdown-toggle"
                onClick={() => toggleDropdown('tornei')}
              >
                <i className="fas fa-trophy"></i>
                Tornei
                <i className={`fas fa-chevron-down dropdown-arrow ${activeDropdown === 'tornei' ? 'rotated' : ''}`}></i>
              </button>
              <ul className="mobile-dropdown-menu">
                <li>
                  <Link to="/tornei/iscrizioni" onClick={closeMobileMenu}>
                    Iscrizioni
                  </Link>
                </li>
                <li>
                  <Link to="/tornei/statistiche" onClick={closeMobileMenu}>
                    Statistiche
                  </Link>
                </li>
              </ul>
            </li>
            
            <li className={`mobile-dropdown ${activeDropdown === 'branche' ? 'active' : ''}`}>
              <button 
                className="mobile-dropdown-toggle"
                onClick={() => toggleDropdown('branche')}
              >
                <i className="fas fa-sitemap"></i>
                Branche
                <i className={`fas fa-chevron-down dropdown-arrow ${activeDropdown === 'branche' ? 'rotated' : ''}`}></i>
              </button>
              <ul className="mobile-dropdown-menu">
                <li>
                  <Link to="branche/lc" onClick={closeMobileMenu}>
                    L/C
                  </Link>
                </li>
                <li>
                  <Link to="/branche/eg" onClick={closeMobileMenu}>
                    E/G
                  </Link>
                </li>
                <li>
                  <Link to="/branche/rs" onClick={closeMobileMenu}>
                    R/S
                  </Link>
                </li>
              </ul>
            </li>
            
            <li>
              <Link to="/regolamento" onClick={closeMobileMenu}>
                <i className="fas fa-book"></i>
                Regolamento
              </Link>
            </li>
            
            <li>
              <Link to="/foto" onClick={closeMobileMenu}>
                <i className="fas fa-camera"></i>
                Foto
              </Link>
            </li>
            
            <li>
              <Link to="/contatti" onClick={closeMobileMenu}>
                <i className="fas fa-envelope"></i>
                Contatti
              </Link>
            </li>
            
            <li className="mobile-login">
              <Link to="/login" onClick={closeMobileMenu} className="mobile-login-btn">
                <i className="fas fa-sign-in-alt"></i>
                Login
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;